import { React, useState } from "react";
import "./landing.css";
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import image from  "./img/switch.png";
import logoutimg from "./img/logout.png";
import imagebk from  "./img/back.png";

function Landing() {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [contact, setContact] = useState("");
    const [pan, setPan] = useState("");
    const [bod, setBod] = useState("");
    const [doj, setDoj] = useState("");
    const [dealername,setDealername]= useState("");
    const [dealerlocation,setDealerlocation]= useState("");
   

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(
            firstName,
            lastName,
            email,
            contact,
           
        );
        if(!firstName||!lastName||!email||!contact||!bod||!doj||!pan||!dealername||!dealerlocation){
            alert("Please fill all the fields")
        }else{
            getUserData();
            
        }
        // Add your form submission logic here
        
    };

    const redirectToLogin = ()=>{
        window.location.href = "/login"
    }

     const handleReset = () => {
        // Reset all state variables here
        setFirstName("");
        setLastName("");
        setEmail("");
        setContact("");
        setPan("")
        setDealername("")
        setDealerlocation("")
        
    };
    const getUserData = ()=>{
       
        let first_name= firstName
        let last_name= lastName
        let birthday= bod
        let mobile_number= parseInt(contact)
        let pan_number= pan
        let email_id= email
        let date_of_join= doj
        let dealer_location= dealerlocation
        let dealership_name= dealername
        
        axios.post('http://127.0.0.1:8000/registration/createusers', {first_name,last_name,birthday,mobile_number,pan_number,email_id,date_of_join,dealer_location,dealership_name})
          .then(function (response) {
            console.log("SuccessFully created");
            alert(response.data);
            handleReset();
          })
          .catch(function (error) {
            console.log(error);
          });
       
    }
    const redirectTodashboard = ()=>{
        window.location.href = "/landingPage"
    }
    return (
        <div className="bg_set">   
         <div className="switch" >
                    <img className="switch-back" onClick={redirectTodashboard} src={imagebk}/>
                    <img className="switch-img" src={image}/>
                    <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
                </div><br/><br/>         
             <div>
            </div>
            <div>
        <div className="Apps ">
            <p className="Headings">Dealer Registration</p>
            <fieldset>
                <form action="#" method="get">
                <div className="row">
                    <div className="col-md-6">
                    <label for="firstname">
                        Dealership Name
                    </label>
                    <input
                        type="text"
                        name="firstname"
                        id="firstname"
                        value={dealername}
                        onChange={(e) =>
                            setDealername(e.target.value)
                        }
                        placeholder="Enter Dealership Name"
                        required
                    />
                    </div>
                    <div className="col-md-6">
                    <label for="lastname">Dealership location</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={dealerlocation}
                        onChange={(e) =>
                            setDealerlocation(e.target.value)
                        }
                        placeholder="Enter location"
                        required
                    />
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-6">
                    <label for="firstname">
                        First Name
                    </label>
                    <input
                        type="text"
                        name="firstname"
                        id="firstname"
                        value={firstName}
                        onChange={(e) =>
                            setFirstName(e.target.value)
                        }
                        placeholder="Enter First Name"
                        required
                    />
                    </div>
                    <div className="col-md-6">
                    <label for="lastname">Last Name</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={lastName}
                        onChange={(e) =>
                            setLastName(e.target.value)
                        }
                        placeholder="Enter Last Name"
                        required
                    />
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-6">
                    <label for="tel">Mobile</label>
                    <input
                        type="number"
                        name="contact"
                        id="contact"
                        value={contact}
                        onChange={(e) =>
                            setContact(e.target.value)
                        }
                        placeholder="Enter Mobile number"
                        required
                    />
                    </div> 
                    <div className="col-md-6">
                    <label for="email">Enter Email </label>
                    <input
                        type="email"
                        name="email"
                        id="email"
                        value={email}
                        onChange={(e) =>
                            setEmail(e.target.value)
                        }
                        placeholder="Enter email"
                        required
                    />  
                    </div>  
                    </div>
                    <div className="row">
                    <div className="col-md-6">
                    <label for="birthday">Birthday:</label>
                        <input type="date"  onChange={(e) =>setBod(e.target.value)} id="birthday" name="birthday"/>
                    </div> 
                    <div className="col-md-6">
                    <label for="DOJ">Date of Join:</label>
                        <input type="date" id="DOJ" onChange={(e) =>setDoj(e.target.value)} name="DOJ"/>  
                    </div>  
                    </div>                      
                      
                      <label for="tel">PAN Number</label>
                    <input
                        type="tel"
                        name="pan"
                        id="pan"
                        value={pan}
                        onChange={(e) =>
                            setPan(e.target.value)
                        }
                        placeholder="Enter PAN number"
                        required
                    />
                    <Button
                        variant="primary"
                        className="btns"
                        type="reset"
                        value="reset"
                        onClick={() => handleReset()}
                    >
                        Reset
                    </Button>
                    <Button
                    variant="primary"
                      className="btns"
                        type="submit"
                        value="Submit"
                        onClick={(e) => handleSubmit(e)}
                    >
                        Submit
                    </Button>
                </form>
            </fieldset>
        </div> 
            </div>
        
        </div>
    );
}


export default Landing;
